'use client'

import { CardCarousel } from '@/components/ui/card-carousel'
import { RelatedResourceCard } from './RelatedResourceCard'
import type { ResolvedResource } from './index'

interface Props {
  resources: ResolvedResource[]
  autoplayDelay?: number
}

export function RelatedResourceCarousel({ resources, autoplayDelay = 10000 }: Props) {
  return (
    <CardCarousel
      items={resources}
      keyExtractor={(r, i) => `${r.href}-${i}`}
      renderDarkCard={(resource) => <RelatedResourceCard resource={resource} variant="dark" />}
      renderLightCard={(resource) => <RelatedResourceCard resource={resource} variant="light" />}
      ariaLabel="Related resources carousel"
      autoplayDelay={autoplayDelay}
    />
  )
}
